<script setup lang="ts">
const { locale } = useI18n()
const { searches, remove, clear } = useRecentSearches()
const isDeletedAll = ref(false)
const mapRecentSearches = computed(() =>
  searches.value.map((search: string) => ({
    text: search,
    url: `${locale.value === 'fr' ? '/fr/' : '/'}search?q=${search}`,
  })),
)

const deleteSearchTerm = (text: string) => {
  remove(text)
  if (!searches.value.length) {
    isDeletedAll.value = true
  }
}
const deleteAllSearchTerm = () => {
  clear()
  isDeletedAll.value = true
}
</script>

<template>
  <section
    v-if="(mapRecentSearches && mapRecentSearches.length) || isDeletedAll"
    class="search__result-section search__recent-searches"
  >
    <h5 class="search__result-section-heading">{{ $t('search_page.search_history') }}</h5>
    <ul v-if="!isDeletedAll" class="search__recent-searches-list">
      <li v-for="item in mapRecentSearches" :key="item.text" data-testid="search-recent-item">
        <a :href="item.url" data-testid="search-recent-term">{{ item.text }}</a>
        <svg-icon
          class="search__close"
          name="mhj:close"
          data-testid="search-recent-remove"
          @click="deleteSearchTerm(item.text)"
          @keyup.enter="deleteSearchTerm(item.text)"
        />
      </li>
      <li>
        <a data-testid="search-recent-clear" @click.prevent="deleteAllSearchTerm">
          {{ $t('search_page.clear_search_history') }}
        </a>
      </li>
    </ul>
    <span v-else class="text-text-tertiary" data-testid="search-recent-empty">{{
      $t('search_page.no_search_history')
    }}</span>
  </section>
</template>

<style lang="postcss">
.search__recent-searches-list {
  li {
    display: flex;
    align-items: center;
    gap: var(--space-30);
  }
  a {
    cursor: pointer;
  }
  .search__close {
    width: var(--space-50);
    height: var(--space-50);
    cursor: pointer;
  }
}
</style>
